import { COLOR, FONT, RADIUS, SEMANTIC_COLOR, SPACE } from '@/shared/design-tokens/design-tokens';
import { escapeHtml, formatMetricValue } from '@/shared/lib/utils';

export const createTooltip = (unit: string) => {
  return {
    trigger: 'axis' as const,
    renderMode: 'html',
    appendToBody: true,
    confine: true,
    backgroundColor: SEMANTIC_COLOR.SURFACE.STANDARD.OPACITY_LEVEL1,
    textStyle: {
      color: SEMANTIC_COLOR.ON_SURFACE.STANDARD.LEVEL1,
      fontSize: FONT.SIZE.SM,
      fontFamily: FONT.FAMILY.NANUMSQUARE,
      fontWeight: FONT.WEIGHT.REGULAR,
    },
    axisPointer: {
      type: 'line' as const,
      lineStyle: {
        color: SEMANTIC_COLOR.CONTAINER.STANDARD.ALT_LEVEL3,
        type: 'solid' as const,
        width: 1,
      },
    },
    borderWidth: 1,
    borderColor: SEMANTIC_COLOR.CONTAINER.STANDARD.ALT_LEVEL4,
    borderRadius: RADIUS[8],
    padding: SPACE[16],
    extraCssText: 'backdrop-filter: blur(4px); box-shadow: none; z-index: 9999;',
    formatter: (params: unknown) => {
      const items = params as {
        axisValueLabel?: string;
        seriesName: string;
        value: number;
        color?: string;
      }[];

      if (!items || items.length === 0) {
        return '';
      }

      const title = items[0].axisValueLabel ?? '';
      const titleHtml =
        title &&
        `<div style="margin-bottom: ${SPACE[12]}px; font-family: ${FONT.FAMILY.NANUMSQUARE}; font-size: ${FONT.SIZE.SM}px; line-height: ${FONT.LINE_HEIGHT[16]}px; font-weight: ${FONT.WEIGHT.REGULAR}; color: ${SEMANTIC_COLOR.ON_SURFACE.STANDARD.LEVEL5}; letter-spacing: 0px;">${escapeHtml(title)}</div>`;

      const itemsHtml = items
        .map((item) => {
          const name = item.seriesName || item.axisValueLabel || '';
          const color = item.color || COLOR.GRAY[50];
          return `
            <div style="display: flex; align-items: center; gap: ${SPACE[4]}px; height: ${SPACE[16]}px; margin-bottom: ${SPACE[4]}px;">
              <div style="
                width: ${SPACE[8]}px;
                height: ${SPACE[8]}px;
                margin: 0 ${SPACE[4]}px;
                border-radius: ${RADIUS.FULL}px;
                background-color: ${color};
                flex-shrink: 0;
              "></div>
              <span style="
                font-family: ${FONT.FAMILY.NANUMSQUARE};
                font-size: ${FONT.SIZE.SM}px;
                line-height: ${FONT.LINE_HEIGHT[16]}px;
                font-weight: ${FONT.WEIGHT.REGULAR};
                color: ${SEMANTIC_COLOR.ON_SURFACE.STANDARD.LEVEL1};
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                flex: 1;
                min-width: 0;
              ">${escapeHtml(name)}</span>
              <span style="
                font-family: ${FONT.FAMILY.NANUMSQUARE};
                font-size: ${FONT.SIZE.SM}px;
                line-height: ${FONT.LINE_HEIGHT[16]}px;
                font-weight: ${FONT.WEIGHT.BOLD};
                color: ${SEMANTIC_COLOR.ON_SURFACE.STANDARD.LEVEL1};
                margin-left: auto;
              ">${formatMetricValue(item.value)} ${unit}</span>
            </div>
          `;
        })
        .join('');

      return `<div style="width: 280px; max-height: 204px; overflow-y: hidden; box-sizing: border-box;">${titleHtml}<div style="display: flex; flex-direction: column; height: "176px"; padding: ${SPACE[16]}px;">${itemsHtml}</div></div>`;
    },
  };
};
